export default class View {
  constructor(node, ...args) {
    this.$node = $(node);
    [this.node] = this.$node;

    // `!== undefined`, not truthiness: a nodeless view is a legitimate mode — a Box of the
    // storage map is built over `null` from the fabric data alone, and every DOM call of it
    // no-ops on the empty $node. A view that does need its node guards on the node at its
    // call site, the way the locale switcher modal does for its v-if blocks
    if (this.initialize && node !== undefined) {
      this.initialize(...args);
    }
  }

  on(...args) {
    return this.$node.on(...args);
  }

  off(...args) {
    return this.$node.off(...args);
  }

  trigger(...args) {
    this.$node.trigger(...args);
  }

  $(selector) {
    return $(selector, this.$node);
  }

  html(html) {
    this.$node.html(html);
  }
}
